import CameraControls from "camera-controls";
import { Vector3 } from "three";

import { Context } from "../../../context";
import { ControllerStrategy } from "../strategy";
import { TrackingControllerStrategy } from "./tracking";

/**
 * Stiff follow player and allow user to pan and rotate the camera relative
 * to that player.
 */
export class SpinControllerStrategy extends TrackingControllerStrategy {
  protected offset: Vector3 = new Vector3(0, 1, 0);
  private cPos: Vector3 = new Vector3();
  private pos: Vector3 = new Vector3();

  protected alphaFactor = 0.1 / 60;

  protected cachedActions: {
    right: any;
    touch: {
      two: any;
    };
  } = {
    right: CameraControls.ACTION.NONE,
    touch: {
      two: CameraControls.ACTION.NONE,
    },
  };

  init(context: Context): ControllerStrategy {
    super.init(context);

    if (!this.registered) {
      console.error("no controller registered");
      return this;
    }

    const { controls } = this.registered;

    if (controls) {
      controls.getTarget(this.cPos);
      controls.getTarget(this.pos);

      this.cachedActions.right = controls.mouseButtons.right;
      this.cachedActions.touch.two = controls.touches.two;

      controls.mouseButtons.right = CameraControls.ACTION.OFFSET;
      controls.touches.two = CameraControls.ACTION.TOUCH_ZOOM;
    }

    return this;
  }

  update(_deltaS: number, _gameTimeDelta: number, frameNum?: number) {
    if (!this.registered || !this.registered.state.tracked) {
      return;
    }

    if (frameNum != undefined) this.lastFrameNum = frameNum;

    if (this.registered.state.tracked) {
      this.cPos.addVectors(this.registered.state.tracked.position, this.offset);

      this.pos.copy(this.cPos);

      this.registered.controls?.moveTo(
        this.pos.x,
        this.pos.y,
        this.pos.z,
        true
      );
    } else {
      console.error("no tracked spin");
    }
  }

  teardown() {
    super.teardown();
    const controls = this.registered?.controls;
    if (controls) {
      controls.setFocalOffset(0, 0, 0);

      controls.mouseButtons.right = this.cachedActions.right;
      controls.touches.two = this.cachedActions.touch.two;
    }
  }
}
